export function getAbsoluteImagePath(imagePath: string) {
  if (imagePath.startsWith("http")) {
    return imagePath;
  }
  if (process.env.NODE_ENV !== "development") {
    return `${window.location.origin}${imagePath}`;
  }
  return `https://integ.partsavatar.ca${imagePath}`;
}
